const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bbaa7dab-29bb-440b-9d21-56322fc3b7ea",
    "data-name": "SVGDoc",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.07 26.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.24,5.41a7.79,7.79,0,0,1,5,1.84L22.19,3.5A13.22,13.22,0,0,0,1.38,7.36l4.44,3.42a7.83,7.83,0,0,1,7.42-5.37Z",
    style: {
      fill: "#d94f3d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41,13.24a7.88,7.88,0,0,1,.41-2.46L1.38,7.36a13.2,13.2,0,0,0,0,11.75l4.44-3.42A7.87,7.87,0,0,1,5.41,13.24Z",
    style: {
      fill: "#f2c042"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.93,10.83H13.3v5.41h7.15A6.44,6.44,0,0,1,17.71,20l4.41,3.39C24.93,20.82,26.58,16.71,25.93,10.83Z",
    style: {
      fill: "#5085ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.71,20a8.44,8.44,0,0,1-4.47,1.11,7.83,7.83,0,0,1-7.42-5.37L1.38,19.11a13.25,13.25,0,0,0,11.86,7.36,13.14,13.14,0,0,0,8.87-3.13Z",
    style: {
      fill: "#57a75c"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.ac6874611efeebb786dfc6fbb3d78f9e.svg";
export { ForwardRef as ReactComponent };